import React, { useState } from 'react';
import s from '../../styles/AdminDocumentMap.module.css';

export interface SubcategoryRow {
  id: string;
  name: string;
  [key: string]: any;
}

interface SubcategoryTableProps {
  rows: SubcategoryRow[];
  onSave: (id: string, name: string) => Promise<void>;
  onDelete: (id: string) => void;
  onDrillIn?: (row: SubcategoryRow) => void;
}

const SubcategoryTable: React.FC<SubcategoryTableProps> = ({ rows, onSave, onDelete, onDrillIn }) => {
  const [editingId, setEditingId] = useState<string | null>(null);
  const [editValue, setEditValue] = useState('');

  const startEdit = (id: string, current: string) => { setEditingId(id); setEditValue(current); };
  const cancel = () => { setEditingId(null); setEditValue(''); };

  const handleSave = async (id: string) => {
    const name = editValue;
    cancel();
    await onSave(id, name);
  };

  if (rows.length === 0) return <p className={s.emptyState}>None yet.</p>;
  return (
    <table className={s.table}>
      <thead>
        <tr>
          <th>Name</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        {rows.map(row => (
          <tr
            key={row.id}
            className={onDrillIn ? s.subcatRow : ''}
            onClick={onDrillIn && editingId !== row.id ? () => onDrillIn(row) : undefined}
          >
            <td>
              {editingId === row.id ? (
                <span className={s.inlineEdit} onClick={e => e.stopPropagation()}>
                  <input
                    className={s.inlineInput}
                    value={editValue}
                    onChange={e => setEditValue(e.target.value)}
                    onKeyDown={e => { if (e.key === 'Enter') handleSave(row.id); if (e.key === 'Escape') cancel(); }}
                    autoFocus
                  />
                  <button className={`${s.btnSm} ${s.btnPrimary}`} onClick={e => { e.stopPropagation(); handleSave(row.id); }}>Save</button>
                  <button className={`${s.btnSm} ${s.btnSecondary}`} onClick={e => { e.stopPropagation(); cancel(); }}>Cancel</button>
                </span>
              ) : (
                <span className={onDrillIn ? s.subcatName : ''}>
                  {row.name ?? '—'}
                  {onDrillIn && <span className={s.drillIcon}>›</span>}
                </span>
              )}
            </td>
            <td onClick={e => e.stopPropagation()}>
              <button className={s.iconBtn} title="Rename" onClick={() => startEdit(row.id, row.name)}>✏️</button>
              <button className={`${s.iconBtn} ${s.iconBtnDanger}`} title="Delete" onClick={() => onDelete(row.id)}>🗑️</button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default SubcategoryTable;
